import { defineMessages } from 'react-intl'

export const processMessages = defineMessages({
  restartProcessTitle: {
    id: 'processMessages.restartProcessTitle',
    description: 'Title of restart process modal window',
    defaultMessage: 'Restart process?',
  },
  restartProcessBody: {
    id: 'processMessages.restartProcessBody',
    description: 'Body of restart process modal window',
    defaultMessage:
      'The software process can only be restarted. A browser refresh may be required.',
  },
  confirmRestartButton: {
    id: 'processMessages.confirmRestartButton',
    description: 'Confirm restart button text',
    defaultMessage: 'Restart',
  },
  confirmResetButton: {
    id: 'processMessages.confirmResetButton',
    description: 'Confirm reset button text',
    defaultMessage: 'Reset',
  },
  confirmRebootButton: {
    id: 'processMessages.confirmRebootButton',
    description: 'Confirm reboot button text',
    defaultMessage: 'Reboot',
  },
  cancelButton: {
    id: 'processMessages.cancelButton',
    description: 'Cancel button text',
    defaultMessage: 'Cancel',
  },
  searchProcess: {
    id: 'processMessages.searchProcess',
    description: 'Search process placeholder',
    defaultMessage: 'Search Processes',
  },
  rebootHardwareTitle: {
    id: 'processMessages.rebootHardwareTitle',
    description: 'Reboot hardware modal title',
    defaultMessage: 'Reboot Hardware?',
  },
  rebootSoftwareTitle: {
    id: 'processMessages.rebootSoftwareTitle',
    description: 'Reboot software title',
    defaultMessage: 'Reboot Software?',
  },
  rebootHardwareBody: {
    id: 'processMessages.rebootHardwareBody',
    description: 'Reboot hardware modal body',
    defaultMessage:
      'The hardware device will be restarted and connection temporarily interrupted.',
  },
  rebootSoftwareBody: {
    id: 'processMessages.rebootSoftwareBody',
    description: 'Reboot software modal body',
    defaultMessage:
      'All host processes will be restarted and connection temporarily interrupted.',
  },
  resetLogLevelButton: {
    id: 'processMessages.resetLogLevelButton',
    description: 'Reset log level button text',
    defaultMessage: 'Reset Log Level',
  },
  hardwareRebootButton: {
    id: 'processMessages.hardwareRebootButton',
    description: 'Hardware reboot button text',
    defaultMessage: 'Hardware Reboot',
  },
  softwareRebootButton: {
    id: 'processMessages.softwareRebootButton',
    description: 'Software reboot button text',
    defaultMessage: 'Software Reboot',
  },
  hostProcess: {
    id: 'processMessages.hostProcess',
    description: 'Host Process title',
    defaultMessage: 'Host Processes',
  },
  closeButton: {
    id: 'processMessages.closeButton',
    description: 'Close Process info button',
    defaultMessage: 'Close',
  },
  CPUUsage: {
    id: 'processMessages.CPUUsage',
    description: 'CPU usage',
    defaultMessage: 'CPU Usage',
  },
  processName: {
    id: 'processMessages.processName',
    description: 'Name of process',
    defaultMessage: 'Name',
  },
  logLevel: {
    id: 'processMessages.logLevel',
    description: 'Log level of process',
    defaultMessage: 'Log Level',
  },
  processStatus: {
    id: 'processMessages.processState',
    description: 'Process status',
    defaultMessage: 'Process Status',
  },
  cpuUsageTitle: {
    id: 'processMessages.cpuUsageTitle',
    description: 'CPU usage field title',
    defaultMessage: 'CPU Usage:',
  },
  virtualMemoryTitle: {
    id: 'processMessages.virtualMemoryTitle',
    description: 'Virtual Memory field title',
    defaultMessage: 'Virtual Memory:',
  },
  physicalMemoryTitle: {
    id: 'processMessages.physicalMemoryTitle',
    description: 'Physical Memory field title',
    defaultMessage: 'Physical Memory:',
  },
  pageFaultsTitle: {
    id: 'processMessages.pageFaultsTitle',
    description: 'Page faults field title',
    defaultMessage: 'Page Faults:',
  },
  processThreadsTitle: {
    id: 'processMessages.processThreadsTitle',
    description: 'Process threads field title',
    defaultMessage: 'Threads:',
  },
  processMessagesSent: {
    id: 'processMessages.processMessagesSent',
    description: 'Process messages sent field title',
    defaultMessage: 'Messages Sent:',
  },
  processMessagesReceived: {
    id: 'processMessages.processMessagesReceived',
    description: 'Messages Received field title',
    defaultMessage: 'Messages Received:',
  },
  processFileDescriptors: {
    id: 'processMessages.processFileDescriptors',
    description: 'Process file descriptors field title',
    defaultMessage: 'File Descriptors:',
  },
  processVersion: {
    id: 'processMessages.processVersion',
    description: 'Process version field title',
    defaultMessage: 'Version:',
  },
  processBuild: {
    id: 'processMessages.processBuild',
    description: 'Process build field title',
    defaultMessage: 'Build:',
  },
  stopProcess: {
    id: 'processMessages.stopProcess',
    description: 'Stop process icon title',
    defaultMessage: 'Stop Process',
  },
  startProcess: {
    id: 'processMessages.startProcess',
    description: 'Start process icon title',
    defaultMessage: 'Start Process',
  },
  resetLogLevelModalTitle: {
    id: 'processMessages.resetLogLevelModalTitle',
    description: 'Reset log level modal title',
    defaultMessage: 'Reset Log Level?',
  },
  processInfoLabel: {
    id: 'processMessages.processInfoLabel',
    description: 'Process info label',
    defaultMessage: 'Process',
  },
  sysStats: {
    id: 'processMessages.sysStats',
    description: 'Heading of a block with Systems Stats (for CPU and Memory)',
    defaultMessage: 'CPU Statistics',
  },
})

export const logLevelMessages = defineMessages({
  emergency: {
    id: 'logLevel.emergency',
    description: '"Emergency" logLevel option',
    defaultMessage: 'Emergency',
  },
  alert: {
    id: 'logLevel.alert',
    description: '"Alert" logLevel option',
    defaultMessage: 'Alert',
  },
  critical: {
    id: 'logLevel.critical',
    description: '"Critical" logLevel option',
    defaultMessage: 'Critical',
  },
  error: {
    id: 'logLevel.error',
    description: '"Error" logLevel option',
    defaultMessage: 'Error',
  },
  warning: {
    id: 'logLevel.warning',
    description: '"Warning" logLevel option',
    defaultMessage: 'Warning',
  },
  notice: {
    id: 'logLevel.notice',
    description: '"Notice" logLevel option',
    defaultMessage: 'Notice',
  },
  info: {
    id: 'logLevel.info',
    description: '"Info" logLevel option',
    defaultMessage: 'Info',
  },
  debug: {
    id: 'logLevel.debug',
    description: '"Debug" logLevel option',
    defaultMessage: 'Debug',
  },
})
